import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import { styles as S } from '@bob/design-system'
import { RichText } from '@bob/rich-text'
import * as entity from '@boutique/entities'

export type CarouselTextsStaticProps = {
  className?: string
  activeIndex?: number
  items: entity.tag.ManifestoTag[]
} & React.HTMLAttributes<HTMLDivElement>

function CarouselTextsStaticComponent({ activeIndex, className, items, ...rest }: CarouselTextsStaticProps) {
  return (
    <div {...rest} className={className}>
      {items.map((item, index) => (
        <CarouselText key={item.name} isActive={activeIndex === index}>
          <S.heading.Title3>{item.name}</S.heading.Title3>
          {item.page?.description && (
            <RichText document={item.page.description.json} links={item.page.description.links} />
          )}
        </CarouselText>
      ))}
    </div>
  )
}

export const CarouselTextsStatic = styled(CarouselTextsStaticComponent)`
  position: relative;
  margin-top: 50px;

  @media screen and (${ds.breakpoint.LAPTOP}) {
    margin-top: 0px;
  }
`

const CarouselText = styled.div<{ isActive?: boolean }>`
  position: ${({ isActive = true }) => (isActive ? 'relative' : 'absolute')};
  opacity: ${({ isActive = true }) => (isActive ? 1 : 0)};
  display: ${({ isActive = true }) => (isActive ? 'block' : 'none')};

  @media screen and (${ds.breakpoint.LAPTOP}) {
    padding-left: 50px;

    ${S.heading.Title3} {
      margin-left: -50px;
    }
  }
`
